export default __webpack_public_path__ + "_/images/freespins/freespins-75-1b15c295339615ba5c9daeb4beed6b35e9e69be928ef8045585dbaa22f1b0d87.png";